import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';
import { Grid, Row, Col } from 'react-bootstrap';

const DEFAULT_OTHER_CONFIG = { currentItemLabel: 'Now', nextItemLabel: 'Next', nextNextItemLabel: 'Later' };

export default function ScheduleEditModule({ eventModuleRow, updateEventModuleRow }) {
    const [scheduleDisplayName, setScheduleDisplayName] = useState(eventModuleRow.name);
    const [bStyle, setBStyle] = useState(eventModuleRow.colour);
    const [other_config, setOtherConfig] = useState(
        eventModuleRow.other_config && Object.entries(eventModuleRow.other_config).length === 3
            ? eventModuleRow.other_config
            : DEFAULT_OTHER_CONFIG
    );

    useEffect(() => {
        setScheduleDisplayName(eventModuleRow.name);
        setBStyle(eventModuleRow.colour);
        if (eventModuleRow.other_config && Object.entries(eventModuleRow.other_config).length === 3) {
            setOtherConfig(eventModuleRow.other_config);
        }
    }, [eventModuleRow]);

    function notify(overrides) {
        updateEventModuleRow({
            name: scheduleDisplayName,
            colour: bStyle,
            other_config,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
            ...overrides,
        });
    }

    function handleChange(e) {
        if (e.target.name === 'scheduleDisplayName') {
            const newName = e.target.value;
            setScheduleDisplayName(newName);
            notify({ name: newName });
        } else {
            const newConfig = { ...other_config, [e.target.name]: e.target.value };
            setOtherConfig(newConfig);
            notify({ other_config: newConfig });
        }
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        notify({ colour: newStyle });
    }

    const inputStyle = { width: '80%' };
    const rowStyle = { marginTop: '5px' };

    return (
        <Grid>
            <Row style={rowStyle}>
                <Col xs={2}>Name</Col>
                <Col xs={4}>
                    <input type="text" style={inputStyle} className="form-control input-md"
                        name="scheduleDisplayName" value={scheduleDisplayName}
                        onChange={handleChange} placeholder="Enter Schedule Display Name" />
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col xs={2} />
                <Col xs={4}>
                    <SelectColourButton
                        title="Select Colour"
                        groupingSequence={eventModuleRow.event_grouping_seq}
                        selectedColour={colourSelected}
                        bStyle={bStyle} />
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col xs={2}>Current Item</Col>
                <Col xs={4}>
                    <input type="text" className="form-control input-md" style={inputStyle}
                        name="currentItemLabel" value={other_config.currentItemLabel}
                        onChange={handleChange} placeholder="Current Item Label" />
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col xs={2}>Next Item</Col>
                <Col xs={4}>
                    <input type="text" className="form-control input-md" style={inputStyle}
                        name="nextItemLabel" value={other_config.nextItemLabel}
                        onChange={handleChange} placeholder="Next Item Label" />
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col xs={2}>Item after Next</Col>
                <Col xs={4}>
                    <input type="text" className="form-control input-md" style={inputStyle}
                        name="nextNextItemLabel" value={other_config.nextNextItemLabel}
                        onChange={handleChange} placeholder="Item after Next Label" />
                </Col>
            </Row>
        </Grid>
    );
}
